import { fetchData } from './api';
import SystemLog from '../types/systemLog';

export interface SystemLogListFilter {
  nivel?: string;
  pageNum?: string;
  quantityPerPage?: string;
  sort?: string;
  order?: string;
}

export const getListaSystemLog = async (filters: SystemLogListFilter) => {
  try {
    const endpoint = '/SystemLog/list';

    const params: Record<string, any> = {
      nivel: filters?.nivel,
      'paginacao.pageNum': filters?.pageNum ? Number(filters.pageNum) + 1 : 1,
      'paginacao.quantityPerPage': filters?.quantityPerPage || '40',
      'paginacao.order': filters?.order,
      'paginacao.sort': filters?.sort,
    };

    for (const key of Object.keys(params)) {
      const value = params[key];
      if (value === undefined || value === null || value === '') {
        delete params[key];
      }
    }

    return await fetchData<SystemLog>(endpoint, params);
  } catch (error) {
    console.error('Erro ao buscar lista de logs do sistema:', error);
    throw error;
  }
};
